import React, { useState } from 'react';
import OTP from "../../kit-components/OTP";
import {Button} from "../../kit-components/Button";
import ResendOTP from "../../kit-components/ResendOTP";
import styles from './otp.module.scss';



export function OtpStep(props) {
  const {
    phoneNumber,
    loading,
    customStyle,
    handleOTPResend,
    handleOTPSubmit,
  } = props;
  const [otp, setOtp] = useState('');

  const handleSubmit = () => {
    handleOTPSubmit(otp);
  };

  return (
    <div>
      <span className={styles['hint']}>
         Please enter the 4-digit code sent to <br/> {phoneNumber}
      </span>

      <div className={styles['otp-container']}>
        <OTP
          length={4}
          onComplete={(otp) => {
            setOtp(otp);
          }}
          customStyle={customStyle.input}
        />
        <div className={styles['resend-otp-msg']}>
          <ResendOTP time={30} onSubmit={handleOTPResend} />
        </div>
      </div>

      <div className={styles['actions']}>
        <Button
          loading={loading}
          label={"Confirm"}
          onClick={handleSubmit}
          customStyle={customStyle.button}
        />
      </div>
    </div>
  );
}

export default OtpStep;
